var map = {
	"./Bitcoin-QR.svg": 8192,
	"./Cardano-QR.svg": 5852,
	"./Ethereum-QR.svg": 7147,
	"./bitcoin.svg": 8080,
	"./cardano.svg": 2684,
	"./ethereum.svg": 8761
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6676;